var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 65,
    viewBox: "0 0 99 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 31,
    r: 14.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0932 26.7119C90.1 27.719 90.7855 29.002 91.0631 30.3986C91.3408 31.7953 91.198 33.2429 90.653 34.5584C90.108 35.8739 89.1851 36.9983 88.0011 37.7894C86.817 38.5805 85.425 39.0027 84.001 39.0027C82.5771 39.0027 81.1851 38.5805 80.001 37.7894C78.817 36.9983 77.8941 35.8739 77.3491 34.5584C76.8041 33.2429 76.6613 31.7953 76.939 30.3986C77.2166 29.002 77.9021 27.719 78.9089 26.7119",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0044 23V31.0003",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2828 1H6.71722C3.55969 1 1 3.30372 1 6.1455V40.8545C1 43.6963 3.55969 46 6.71722 46H45.2828C48.4403 46 51 43.6963 51 40.8545V6.1455C51 3.30372 48.4403 1 45.2828 1Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 37C34.2843 37 41 31.1797 41 24C41 16.8203 34.2843 11 26 11C17.7157 11 11 16.8203 11 24C11 31.1797 17.7157 37 26 37Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59C36.7885 62.2308 31.481 64 25.9999 64C20.519 64 15.2113 62.2308 11 59",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52C30.2471 53.9515 28.1502 55 25.9999 55C23.8498 55 21.7529 53.9515 20 52",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon6);
export default __webpack_public_path__ + "static/media/faq-icon6.268c3ccd7910fe314afef867f1f2676e.svg";
export { ForwardRef as ReactComponent };